class sseclient {
	constructor(url, { headers = {} } = {}) {
		this.url = url;
		this.headers = headers;
		this.controller = new AbortController();
		this.eventHandlers = {
			open: [],
			error: [],
			message: [] // default event type
		};
	}

	// Register event handlers
	on(eventType, callback) {
		if (!this.eventHandlers[eventType]) {
			this.eventHandlers[eventType] = [];
		}
		this.eventHandlers[eventType].push(callback);
	}

	// Internal: dispatch event
	_dispatch(eventType, data) {
		if (this.eventHandlers[eventType]) {
			this.eventHandlers[eventType].forEach(cb => cb(data));
		}
	}

	// Connect to SSE endpoint
	async connect() {
		this.controller = new AbortController();
		try {
			const response = await fetch(this.url, {
				method: "GET",
				headers: {
					"Accept": "text/event-stream",
					...this.headers
				},
				signal: this.controller.signal
			});

			if (!response.ok) {
				throw new Error(`SSE connection failed: ${response.status} ${response.statusText}`);
			}

			this._dispatch("open");

			const reader = response.body.getReader();
			const decoder = new TextDecoder("utf-8");
			let buffer = "";

			while (true) {
				const { value, done } = await reader.read();
				if (done) break;

				buffer += decoder.decode(value, { stream: true });

				let events = buffer.split("\n\n");
				buffer = events.pop(); // keep incomplete chunk

				for (const rawEvent of events) {
					let eventType = "message";
					let data = "";

					rawEvent.split("\n").forEach(line => {
						if (line.startsWith("event:")) {
							eventType = line.replace(/^event:\s*/, "");
						} else if (line.startsWith("data:")) {
							data += line.replace(/^data:\s*/, "") + "\n";
						}
					});

					data = data.trim();

					if (data) {
						this._dispatch(eventType, data);
					}
				}
			}
		} catch (err) {
			this._dispatch("error", err);
		}
	}

	// Close connection
	close() {
		console.log("connection closed");
		this.controller.abort();
	}
}


export default sseclient;
	